
import withStyles from '@mui/styles/withStyles';
import MuiButton from '@mui/material/Button';

import CommonTheme from '../../../Theme.js';

/** ボタン共通部で使用するパレット */
const palette = CommonTheme.palette;

// ボタン共通スタイル
const styles = (theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      'minWidth': 'auto', // 180,
    },
    'border': '1px solid',
    'whiteSpace': 'nowrap',

    '&:disabled': {
      color: palette.text.disabled,
      backgroundImage: 'none',
      backgroundColor: palette.action.disabledBackground,
    },

    '&:hover': {
      backgroundColor: CommonTheme.mouse.color,
    },
  },

});

/** ボタン共通部 */
export const CommonButton = withStyles(styles)(MuiButton);
export default CommonButton;
